import { AccessoryType } from './enums';

export class Accessory {
    id: number;
    name = '';
    quantity: number = 1;
    urlPhoto? = '';
    accessoryType: AccessoryType;
}
